<template>
  <div class="default-page">
    <div v-show="step === 'work-form'" class="step-panel mt-4">
      <timer-block v-if="+user.use_timer" class="mb-5" />
      <shift-block />
    </div>
  </div>
</template>

<script>
import { UserModel } from "@/models/UserModel";
import TimerBlock from "@/components/TimerBlock";
import ShiftBlock from "@/components/ShiftBlock";

export default {
  name: 'DashboardPage',
  components: {
    TimerBlock,
    ShiftBlock
  },
  data() {
    return {
      step: 'work-form',
      user: UserModel.current(),
    }
  }
}
</script>

<style lang="scss" scoped>
.step-panel {
  &-by-center {
    min-height: calc(100vh - 60px - 30px); // 60px=нижнее меню, 30px=два отступа по 15 сверху и низу страницы
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 !important;
  }
}
</style>